module.exports = "<div [hidden]=\"!active\" class=\"pane fx-full-height\">\n        <ng-content></ng-content>\n</div>"